import { Link } from 'react-router-dom';

// Mobile-only catch-all menu for destinations that don't fit the 5-slot bottom
// tab bar. On desktop these live in the sidebar, so this page is still reachable
// but rarely needed there.
const ITEMS = [
  { to: '/invoices', label: 'Invoices', icon: '🧾' },
  { to: '/mileage', label: 'Mileage', icon: '🚗' },
  { to: '/broadcast', label: 'Broadcast', icon: '📣' },
  { to: '/discover', label: 'Find families', icon: '🔍' },
  { to: '/documents', label: 'Documents', icon: '📁' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
];

export function MorePage() {
  return (
    <div>
      <h1>More</h1>
      <div className="card" style={{ padding: '4px 0', marginTop: 16 }}>
        {ITEMS.map((it) => (
          <Link
            key={it.to}
            to={it.to}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 14,
              padding: '14px 16px',
              borderBottom: '1px solid var(--divider)',
              color: 'inherit',
              fontWeight: 600,
              fontSize: 15,
            }}
          >
            <span style={{ fontSize: 18 }}>{it.icon}</span>
            {it.label}
            <span style={{ marginLeft: 'auto', color: 'var(--text-tertiary)', fontSize: 20 }}>›</span>
          </Link>
        ))}
      </div>
    </div>
  );
}
